import { Chip, ChipProps } from "@components/ui/Chip"
import { useFilmBadges } from "@features/program/useFilmBadges"
import { FilmSessionFragment, FilmTileFragment, SessionTicketsFragment } from "@generated-types"
import { cn, tv } from "@utils/tw"
import { memo } from "react"

type Props = {
  film?: FilmTileFragment
  session?: FilmSessionFragment | SessionTicketsFragment
  shape?: ChipProps["shape"]
  className?: string
}

export const EventBadges = memo((props: Props) => {
  const badges = useFilmBadges(props)

  return (
    <>
      {badges.map((badge, i) => {
        return (
          <Chip
            key={i}
            className={cn("bg-black", props.className, eventBadgeStyle({ variant: badge.type as any }))}
            data-badge={badge.type}
            shape={props.shape}
            leftIcon={badge.icon}
          >
            {badge.label}
          </Chip>
        )
      })}
    </>
  )
})

export const eventBadgeStyle = tv({
  base: "pointer-events-none",
  variants: {
    variant: {
      "sold-out": "bg-coral text-black",
      "selling-fast": "bg-orange text-black",
      "past-event": "bg-black text-white/70",
      short: "bg-[#4EFF67] text-black",
    },
  },
})
